// extracted by mini-css-extract-plugin
module.exports = {"button":"detailsCard_button__x-GOw","topMargin":"detailsCard_topMargin__kHeRS"};